module.exports = __webpack_public_path__ + "img/Thought.a8106c8c.svg";